import './DealModalBlock.css';
import React from 'react';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as PlusImg } from '../../../resources/icons/gray-plus.svg';
import { ReactComponent as MinusImg } from '../../../resources/icons/gray-minus.svg';
import grayPlusImg from '../../../resources/icons/gray-plus.svg';
import bluePlusImg from '../../../resources/icons/blue-plus.svg';
import grayMinusImg from '../../../resources/icons/gray-minus.svg';
import blueMinusImg from '../../../resources/icons/blue-minus.svg';
import { ReactComponent as IconCalendar } from '../../../resources/icons/IconCalendar.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { get, getDictionaryItem, canUseDOM, pathJoin, getMediaHost, injectImageResolution, getGlobalDictionaryTerm } from '../../../utils';
import LazyPicture from '../../atoms/LazyPicture';
import { useLocation } from 'react-router-dom';
const getFormatedDate = (date, lang) => {
  return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};
const convertDate = function (startDate, endDate) {
  let lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-GB';
  const date = [];
  if (startDate) {
    date.push(getFormatedDate(startDate, lang));
  }
  if (endDate) {
    date.push(getFormatedDate(endDate, lang));
  }
  return date.join(' - ');
};
const typesDealsFields = {
  // Leisure
  'Listing deal': {
    location: 'dealLocation',
    locationTag: 'locationtags',
    dealtypetags: 'dealtypetags',
    categorytags: 'categoryTags',
    category: 'category',
    phone: 'phone',
    email: 'email',
    moreinfo: 'moreinfo',
    partner: 'partners',
    promoCode: 'redemptionCode',
    isFeatured: 'dealfeatured',
    featuredColor: '#C22C91',
    termsandconditions: 'termsandconditions',
    bookNow: 'bookLink',
    bookNowLabelField: 'Book now',
    bookNowColor: '#007CBA',
    labelHoverColor: 'blue'
  },
  // Buisiness
  'Listing vendor': {
    location: 'locationtags',
    event: 'eventtags',
    dealtypetags: 'dealtypetags',
    categorytags: 'categoryTags',
    category: 'category',
    eventsizetags: 'eventsizetags',
    services: 'servicetags',
    marketspecialisation: 'marketspecialisationtags',
    phone: 'phone',
    email: 'email',
    moreinfo: 'moreinfo',
    isFeatured: 'dealfeatured',
    featuredColor: '#17808E',
    languages: 'languagetags',
    bookNow: 'listingvendorswebsite',
    bookNowLabelField: 'Visit website',
    bookNowColor: '#007CBA',
    labelHoverColor: 'blue'
  },
  // Trade
  'Listing trade event': {
    category: 'category',
    categorytags: 'categoryTags',
    location: 'locationtags',
    dealtypetags: 'dealtypetags',
    standnumber: 'standnumber',
    phone: 'phone',
    email: 'email',
    moreinfo: 'moreinfo',
    isFeatured: 'dealfeatured',
    featuredColor: '#007CBA',
    bookNow: 'registerurl',
    bookNowLabelField: 'Register now',
    bookNowColor: '#6D6E6E',
    labelHoverColor: 'gray'
  }
};
export const TermsAndConditions = _ref => {
  let {
    termsandconditions,
    label,
    color,
    expandCollapseAnalytics,
    params,
    englishTitle
  } = _ref;
  const [isHidden, setHidden] = React.useState(true);
  const isGrayColor = color === 'gray' ? '' : 'deals__details-item--icon';
  return /*#__PURE__*/React.createElement("div", {
    className: "deals__terms-and-conditions-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'deals__details-item deals__terms-and-conditions',
    onClick: () => {
      setHidden(!isHidden);
      tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? `Show: ${englishTitle}` : `Hide:  ${englishTitle}`);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: `bold-text terms-and-conditions-label hover-label-color-${color}`
  }, label), isHidden ? /*#__PURE__*/React.createElement(PlusImg, {
    className: `${isGrayColor} datails-expand-img`
  }) : /*#__PURE__*/React.createElement(MinusImg, {
    className: `${isGrayColor} datails-expand-img`
  })), !isHidden && /*#__PURE__*/React.createElement("div", {
    className: "",
    dangerouslySetInnerHTML: {
      __html: termsandconditions
    }
  }));
};
export const DealModalBlock = _ref2 => {
  let {
    event,
    lang,
    route,
    params,
    fields,
    hostLink,
    analytics,
    name,
    pageTitle,
    rtl
  } = _ref2;
  const sitecoreContext = useSitecoreContext();
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const imgAlt = get(event, 'title');
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), event.image])}`, 440, 440);
  const [isHidden, setHidden] = React.useState(true);
  const {
    expandCollapseAnalytics,
    buttonClickAnalytics
  } = analytics;
  const eventType = event.type.toString();
  const socialSharing = get(fields, 'data.socialSharing.socialLinks.values') || [];
  const likeButtonsTitle = encodeURIComponent(get(fields, 'data.socialSharing.likeButtonsTitle.jss.value'));
  const title = get(fields, 'data.socialSharing.title.jss.value') || '';
  var [isMobile, setIsMobile] = React.useState(false);
  const fNames = typesDealsFields[eventType];
  const locationURL = useLocation();
  const checkIsMobile = () => {
    const isMobile = canUseDOM && window.innerWidth <= 767;
    setIsMobile(isMobile);
  };
  React.useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('resize', checkIsMobile);
      const interval = setInterval(checkIsMobile, 1000);
      return () => {
        window.removeEventListener('resize', checkIsMobile);
        clearInterval(interval);
      };
    }
  }, []);
  if (!fNames) {
    return null;
  }
  const dictionary = get(fields, 'data.dictionary');
  const featuredText = getDictionaryItem(dictionary, 'Featured') || 'featured';
  const eventsText = getDictionaryItem(dictionary, 'Events') || 'Events:';
  const categoryText = getDictionaryItem(dictionary, 'Category') || 'Category:';
  const eventSizeText = getDictionaryItem(dictionary, 'Event size') || 'Event size:';
  const servicesText = getDictionaryItem(dictionary, 'Services') || 'Services:';
  const maketSpecialisationText = getDictionaryItem(dictionary, 'Maket specialisation') || 'Maket specialisation:';
  const languagesText = getDictionaryItem(dictionary, 'Languages') || 'Languages:';
  const bookNowText = getDictionaryItem(dictionary, fNames.bookNowLabelField) || 'Book now';
  const priorBookNowText = get(event, 'dealBookLabel') || bookNowText;
  const detailsText = getDictionaryItem(dictionary, 'Details') || 'Details listing';
  const locationsText = getDictionaryItem(dictionary, 'Locations') || 'Locations:';
  const locationListText = getDictionaryItem(dictionary, 'LocationsList') || 'Location:';
  const dealtypetagsText = getDictionaryItem(dictionary, 'Deal type') || 'Deal type:';
  const promoCodeText = getDictionaryItem(dictionary, 'Promo code') || 'Promo code:';
  const standNumberText = getDictionaryItem(dictionary, 'Stand number') || 'Stand number:';
  const emailText = getDictionaryItem(dictionary, 'Email') || 'Email:';
  const phoneText = getDictionaryItem(dictionary, 'Phone') || 'Phone:';
  const aboutText = getDictionaryItem(dictionary, 'About') || 'About:';
  const termsAndConditionsText = getDictionaryItem(dictionary, 'Terms and Conditions') || 'Terms and Conditions';
  const moreinfoText = getDictionaryItem(dictionary, 'More info') || 'More info:';
  const location = event[fNames.location];
  const locationTag = event[fNames.locationTag];
  const dealtypetags = event[fNames.dealtypetags];
  const isFeatured = event[fNames.isFeatured];
  const featuredColor = fNames.featuredColor;
  const events = event[fNames.event];
  const eventsizetags = event[fNames.eventsizetags];
  const category = event[fNames.category];
  const categorytags = event[fNames.categorytags] || event.categorytags;
  const bookNow = event[fNames.bookNow];
  const bookNowColor = fNames.bookNowColor;
  const labelHoverColor = fNames.labelHoverColor;
  const marketspecialisation = event[fNames.marketspecialisation];
  const services = event[fNames.services];
  const languages = event[fNames.languages];
  const standnumber = event[fNames.standnumber];
  const phone = event[fNames.phone];
  const email = event[fNames.email];
  const moreinfo = event[fNames.moreinfo];
  const termsandconditions = event[fNames.termsandconditions];
  const BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  const qIndex = email ? email.indexOf('?') : -1;
  const fixedEmail = ~qIndex ? email.slice(0, qIndex) : email;
  const featured = isFeatured && featuredColor ? /*#__PURE__*/React.createElement(React.Fragment, null, category && /*#__PURE__*/React.createElement("span", null, ' · '), /*#__PURE__*/React.createElement("span", {
    className: "featured-tag",
    style: {
      color: featuredColor
    }
  }, featuredText)) : '';
  const renderTags = function () {
    let tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return tags.map((tag, index) => {
      return index ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, ' · '), /*#__PURE__*/React.createElement("span", null, tag)) : /*#__PURE__*/React.createElement("span", null, tag);
    });
  };
  const mobileAccordion = /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deals__details-item"
  }, /*#__PURE__*/React.createElement("button", {
    className: `btn--reset hover-label-color hover-label-color-${labelHoverColor}`,
    onClick: () => {
      setHidden(!isHidden);
      tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? `Show: ${event.englishTitle}` : `Hide:  ${event.englishTitle}`);
    }
  }, detailsText), /*#__PURE__*/React.createElement("button", {
    className: "btn--reset",
    onClick: () => {
      setHidden(!isHidden);
      tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? `Show: ${event.englishTitle}` : `Hide:  ${event.englishTitle}`);
    }
  }, labelHoverColor == 'blue' ? /*#__PURE__*/React.createElement("img", {
    alt: "expand",
    className: "datails-expand-img",
    src: isHidden ? bluePlusImg : blueMinusImg
  }) : /*#__PURE__*/React.createElement("img", {
    alt: "expand",
    className: "datails-expand-img",
    src: isHidden ? grayPlusImg : grayMinusImg
  }))), /*#__PURE__*/React.createElement("div", {
    className: `intro-text-block  ${isHidden ? '' : 'expanded'}`
  }, !isHidden && /*#__PURE__*/React.createElement(React.Fragment, null, events && /*#__PURE__*/React.createElement("div", {
    className: "details-items deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-item events"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, eventsText, " "), /*#__PURE__*/React.createElement("span", null, events.join(', ')))), eventsizetags && /*#__PURE__*/React.createElement("div", {
    className: "eventsizetags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, eventSizeText, " "), /*#__PURE__*/React.createElement("span", null, eventsizetags.join(', '))), services && /*#__PURE__*/React.createElement("div", {
    className: "services deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, servicesText, " "), /*#__PURE__*/React.createElement("span", null, services.join(', '))), marketspecialisation && /*#__PURE__*/React.createElement("div", {
    className: "marketspecialisation deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, maketSpecialisationText, " "), /*#__PURE__*/React.createElement("span", null, marketspecialisation.join(', '))), languages && /*#__PURE__*/React.createElement("div", {
    className: "languages deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, languagesText, " "), /*#__PURE__*/React.createElement("span", null, languages.join(', '))), location && /*#__PURE__*/React.createElement("div", {
    className: "locationtags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, locationsText, " "), /*#__PURE__*/React.createElement("span", null, typeof location === 'string' ? location : location.join(', '))), locationTag && /*#__PURE__*/React.createElement("div", {
    className: "locationtags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, locationListText, " "), /*#__PURE__*/React.createElement("span", null, locationTag.join(', '))), dealtypetags && /*#__PURE__*/React.createElement("div", {
    className: "locationtags dealtypetags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, dealtypetagsText, " "), /*#__PURE__*/React.createElement("span", null, dealtypetags.join(', '))), categorytags && /*#__PURE__*/React.createElement("div", {
    className: "locationtags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, categoryText, " "), /*#__PURE__*/React.createElement("span", null, categorytags.join(', '))), event.bookingcode && /*#__PURE__*/React.createElement("div", {
    className: "details-item promoCode deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, promoCodeText, " "), /*#__PURE__*/React.createElement("span", null, event.bookingcode)), standnumber && /*#__PURE__*/React.createElement("div", {
    className: "details-item standnumber deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, standNumberText, " "), /*#__PURE__*/React.createElement("span", null, standnumber)), eventType !== 'Listing deal' && phone && /*#__PURE__*/React.createElement("div", {
    className: "details-item phone deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, phoneText, " "), /*#__PURE__*/React.createElement("a", {
    className: 'contact-field-link deal-modal__info-item-underline',
    href: `tel:${phone}`
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field'
  }, phone))), event.abouttext && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bold-text"
  }, aboutText, " "), /*#__PURE__*/React.createElement("div", {
    className: "intro-text deal-text deal-modal__info-item",
    dangerouslySetInnerHTML: {
      __html: event.abouttext
    }
  })), eventType === 'Listing deal' && phone && /*#__PURE__*/React.createElement("div", {
    className: "details-item phone deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, phoneText, " "), /*#__PURE__*/React.createElement("span", {
    className: 'contact-field-link desktop deal-modal__info-item-underline'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field hide-default-color-link'
  }, phone))), email && /*#__PURE__*/React.createElement("div", {
    className: "details-item email deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, emailText, " "), /*#__PURE__*/React.createElement("a", {
    className: 'contact-field-link deal-modal__info-item-underline',
    href: `${fixedEmail}`
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field hide-default-color-link'
  }, fixedEmail.indexOf('mailto:') === 0 ? fixedEmail.slice(7) : fixedEmail))), moreinfo && /*#__PURE__*/React.createElement("div", {
    className: "details-item moreinfo"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, moreinfoText, " "), /*#__PURE__*/React.createElement("div", {
    className: "intro-text moreinfo",
    dangerouslySetInnerHTML: {
      __html: moreinfo
    }
  })), termsandconditions && /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__info-item"
  }), termsandconditions && /*#__PURE__*/React.createElement(TermsAndConditions, {
    label: termsAndConditionsText,
    termsandconditions: termsandconditions,
    color: labelHoverColor,
    expandCollapseAnalytics: expandCollapseAnalytics,
    params: params,
    englishTitle: event.englishTitle
  }))));
  const desktopInformation = /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "intro-text-block"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, events && /*#__PURE__*/React.createElement("div", {
    className: "details-items deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-item events"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, eventsText, " "), /*#__PURE__*/React.createElement("span", null, events.join(', ')))), eventsizetags && /*#__PURE__*/React.createElement("div", {
    className: "eventsizetags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, eventSizeText, " "), /*#__PURE__*/React.createElement("span", null, eventsizetags.join(', '))), services && /*#__PURE__*/React.createElement("div", {
    className: "services deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, servicesText, " "), /*#__PURE__*/React.createElement("span", null, services.join(', '))), marketspecialisation && /*#__PURE__*/React.createElement("div", {
    className: "marketspecialisation deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, maketSpecialisationText, " "), /*#__PURE__*/React.createElement("span", null, marketspecialisation.join(', '))), languages && /*#__PURE__*/React.createElement("div", {
    className: "languages deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, languagesText, " "), /*#__PURE__*/React.createElement("span", null, languages.join(', '))), location && /*#__PURE__*/React.createElement("div", {
    className: "locationtags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, locationsText, " "), /*#__PURE__*/React.createElement("span", null, typeof location === 'string' ? location : location.join(', '))), locationTag && /*#__PURE__*/React.createElement("div", {
    className: "locationtags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, locationListText, " "), /*#__PURE__*/React.createElement("span", null, locationTag.join(', '))), dealtypetags && /*#__PURE__*/React.createElement("div", {
    className: "locationtags dealtypetags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, dealtypetagsText, " "), /*#__PURE__*/React.createElement("span", null, dealtypetags.join(', '))), categorytags && /*#__PURE__*/React.createElement("div", {
    className: "locationtags deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, categoryText, " "), /*#__PURE__*/React.createElement("span", null, categorytags.join(', '))), event.bookingcode && /*#__PURE__*/React.createElement("div", {
    className: "details-item promoCode deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, promoCodeText, " "), /*#__PURE__*/React.createElement("span", null, event.bookingcode)), standnumber && /*#__PURE__*/React.createElement("div", {
    className: "details-item standnumber deal-modal__info-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, standNumberText, " "), /*#__PURE__*/React.createElement("span", null, standnumber)), event.abouttext && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bold-text"
  }, aboutText, " "), /*#__PURE__*/React.createElement("div", {
    className: "intro-text deal-text deal-modal__info-item",
    dangerouslySetInnerHTML: {
      __html: event.abouttext
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "row deal-modal__info-item deal-modal__info-item--row-with-2 "
  }, eventType === 'Listing deal' && phone && /*#__PURE__*/React.createElement("div", {
    className: "details-item phone col-5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, phoneText, " "), /*#__PURE__*/React.createElement("span", {
    className: 'contact-field-link desktop deal-modal__info-item-underline'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field hide-default-color-link'
  }, phone))), eventType !== 'Listing deal' && phone && /*#__PURE__*/React.createElement("div", {
    className: "details-item phone col-5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, phoneText, " "), /*#__PURE__*/React.createElement("a", {
    className: 'contact-field-link deal-modal__info-item-underline',
    href: `tel:${phone}`
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field'
  }, phone))), email && /*#__PURE__*/React.createElement("div", {
    className: "details-item email col-5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, emailText, " "), /*#__PURE__*/React.createElement("a", {
    className: 'contact-field-link deal-modal__info-item-underline',
    href: `${fixedEmail}`
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field hide-default-color-link'
  }, fixedEmail.indexOf('mailto:') === 0 ? fixedEmail.slice(7) : fixedEmail)))), moreinfo && /*#__PURE__*/React.createElement("div", {
    className: "details-item moreinfo"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, moreinfoText, " "), /*#__PURE__*/React.createElement("div", {
    className: "intro-text moreinfo",
    dangerouslySetInnerHTML: {
      __html: moreinfo
    }
  })), termsandconditions && /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__info-item"
  }), termsandconditions && /*#__PURE__*/React.createElement(TermsAndConditions, {
    label: termsAndConditionsText,
    termsandconditions: termsandconditions,
    color: labelHoverColor,
    expandCollapseAnalytics: expandCollapseAnalytics,
    params: params,
    englishTitle: event.englishTitle
  }))));
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal-modal",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: "deal-modal__title"
  }, pageTitle), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__image col-md-4 col-12"
  }, event.image && /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "deals__image",
    src: imgSrc,
    alt: imgAlt
  })), isFeatured && /*#__PURE__*/React.createElement("div", {
    className: "ribbon",
    style: {
      backgroundColor: featuredColor
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__content col-md-8 col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deals__category"
  }, eventType === 'Listing deal' ? renderTags(event.category) : renderTags(event.visibletags), featured), /*#__PURE__*/React.createElement("div", {
    className: "deals__item-title"
  }, event.title), eventType === 'Listing deal' && /*#__PURE__*/React.createElement("div", {
    className: "deals__tags"
  }, renderTags(event.visibletags)), (event.validTo || event.validFrom) && /*#__PURE__*/React.createElement("div", {
    className: `deals__date-item ${eventType === 'Listing trade event' ? 'deals__date-item-trade' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(IconCalendar, null)), convertDate(event.validFrom, event.validTo, lang)), isMobile ? mobileAccordion : desktopInformation), /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__footer"
  }, bookNow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "book-now-button-box"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn btn-primary book-now-button",
    href: bookNow,
    style: {
      backgroundColor: bookNowColor
    },
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": `${priorBookNowText} | ${newWindowLabel}`,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(buttonClickAnalytics, params), 'Book now:' + event.englishTitle)
  }, priorBookNowText))), /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__social-sharing"
  }, /*#__PURE__*/React.createElement("p", {
    className: "deal-modal__social-sharing-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "deal-modal__link"
  }, socialSharing.map(item => {
    const icon = get(item, 'icon.jss.value.src');
    const iconAlt = get(item, 'icon.jss.value.alt');
    let link = get(item, 'link.jss.value', '');
    const svgIcon = get(item, 'svgIcon.jss.value');
    const nameSocial = get(item, 'name');
    const shareURLSearch = canUseDOM ? `${locationURL && encodeURI(locationURL.pathname.replaceAll(' ', '%20'))}/share/${encodeURIComponent(event.urlParameter).replaceAll('%20', '-')}` : '';
    if (link) link = link.replace('${message}', likeButtonsTitle).replace('${link}', origin + shareURLSearch);
    return /*#__PURE__*/React.createElement("a", {
      href: link,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "deal-modal__social-icon",
      "aria-label": `${nameSocial} | ${newWindowLabel}`,
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.click();
        }
      },
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(analytics, params), `${item.name} : ${route.name}`);
      }
    }, svgIcon ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "social-sharing__a-icon"
    }) : /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true,
      className: nameSocial
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: BASE_URL + icon
    }), /*#__PURE__*/React.createElement("img", {
      className: "social-sharing__icon",
      src: BASE_URL + icon,
      alt: iconAlt,
      title: iconAlt
    })));
  }))))))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `  ${commonStyle}  ${rtl ? rtlStyle : ltlStyle} `
  }, children);
};
const commonStyle = "cpe7chz";
const rtlStyle = "r3xzwl1";
const ltlStyle = "l1d3lai7";